export default {
  loginTitle: '登录到',
  noAccount: '没有账号吗?',
  existAccount: '已有账号?',
  createAccount: '注册新账号',
  remember: '记住账号',
  forget: '忘记账号',
  signIn: '登录',
  register: '注册',
  refresh: '刷新',
  wechatLogin: '使用微信扫一扫登录',
  accountLogin: '使用账号登录',
  phoneLogin: '使用手机号登录',
  input: {
    account: '请输入账号',
    password: '请输入登录密码',
    phone: '请输入手机号',
    verification: '请输入验证码',
  },
  required: {
    account: '账号必填',
    phone: '手机号必填',
    password: '密码必填',
    verification: '验证码必填',
  },
  sendVerification: '发送验证码',
};
